/** @jsxImportSource @emotion/react **/
import React, { FC, useContext, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import Select from 'react-select'

import { LANG_ALL, styleContainer } from '../../../pages/utils'
import { Context } from '../../../context/StaffTeamContext'
import { BaseInput, Text } from '../../atoms'
import { ContentSection } from '../../organisms'
import MediaField from '../MediaField'
import * as styles from '../Header/index.styles'

const StaffTeamForm: FC = () => {
  const {
    formData,
    handleChangeFormData: handleChange,
    handleUpdateFormData: handleData,
  } = useContext(Context)

  const { id } = useParams()

  const detailData = useSelector((state: any) => state.get_staff_cards.data)
  const staffData = id ? detailData?.data?.find((r: any) => r.id === id) : null

  const langInit = staffData?.lang
    ? { value: staffData.lang, label: staffData.lang }
    : { value: '', label: '' }

  useEffect(() => {
    if (id && staffData) {
      handleData(staffData)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, staffData])

  const handleLang = (e: any) => {
    handleChange({ lang: e.value })
  }

  return (
    <ContentSection
      style={styleContainer}
      header={
        <React.Fragment>
          <Text textType="h4" weight="black">
            {id ? 'Editar' : 'Nuevo'} integrante del equipo
          </Text>
        </React.Fragment>
      }
    >
      <BaseInput
        label="Nombre"
        value={formData.name}
        onChange={(value) => handleChange({ name: value })}
        placeholder="Escribe el nombre"
        maxLength={500}
      />

      <BaseInput
        label="Cargo"
        value={formData.job_position}
        onChange={(value) => handleChange({ job_position: value })}
        placeholder="Escribe el cargo"
        maxLength={500}
      />

      <MediaField
        label="Imagen"
        value={formData.image}
        folder="staff-team"
        onChange={(url) => handleChange({ image: url })}
      />

      <Text textType="label">
        IDIOMA:{' '}
        <Select
          css={styles.input}
          options={LANG_ALL}
          defaultValue={langInit}
          onChange={(e) => handleLang(e)}
        />
      </Text>
    </ContentSection>
  )
}

export default StaffTeamForm
